const headerFontFamily = ['Poppins', 'Helvetica', 'Arial', 'sans-serif'].join(
  ', ',
);
const bodyFontFamily = ['Inter', 'Helvetica', 'Arial', 'sans-serif'].join(', ');

const common = {
  black: '#000000',
  white: '#FFF',
  transparentGray: 'rgba(255, 255, 255, 0.2)',
};

const text = {
  primary: '#364153',
  secondary: '#515252',
  dark: '#222222',
  gray: '#898989',
  darkGray: '#363636',
};

const primary = {
  contrastText: '#FFFFFF',
  main: '#FF2800',
  dark: '#D92200',
  light: '#FF4826',
  accent: '#FFF8F9',
};

const secondary = {
  contrastText: '#FFFFFF',
  main: '#222222',
  dark: '#000000',
  lightDark: '#364153',
  light: '#484848',
  accent: '#F7F7F7',
};

const tertiary = {
  contrastText: '#FFF',
  dark: '#5E4006',
  main: '#F8C051',
  light: '#FFD873',
  accent: '#FCF4DD',
};

const success = {
  contrastText: '#FFFFFF',
  main: '#008489', // Airbnb teal (used for trust/success messages)
  dark: '#006C6F',
  light: '#33A3A7',
  accent: '#E6F7F7',
};

const danger = {
  contrastText: '#FFFFFF',
  main: '#D93900', // Airbnb error red
  dark: '#A62C00',
  light: '#FF5A36',
  accent: '#FFEDE8',
};

const warning = {
  contrastText: '#FFFFFF',
  main: '#E07900',
  dark: '#A85A00',
  light: '#FFA940',
  accent: '#FFF4E6',
};

const neutral = {
  contrastText: '#FFFFFF',
  main: '#222222',
  overlay: 'rgba(0, 0, 0, 0.4)',
  gray: '#B0B0B0',
  light: '#F7F7F7',
};

const mono = {
  contrastText: '#FFFFFF',
  dark: '#DADADA',
  main: '#EBEBEB',
  light: '#F7F7F7',
  accent: '#FAFAFA',
};
const breakpoint = {
  xs: 0,
  sm: 600,
  md: 1024,
  lg: 1360,
  xl: 1680,
};

const borderRadius = {
  xs: '8px',
  sm: '10px',
  md: '16px',
  lg: '20px',
  xl: '24px',
};

const fontSize = {
  sm: '14px',
  md: '18px',
  lg: '24px',
};

export const DesignTokens = {
  bodyFontFamily,
  headerFontFamily,
  color: {
    common,
    text,
    primary,
    secondary,
    tertiary,
    success,
    danger,
    warning,
    mono,
    neutral,
  },
  breakpoint,
  borderRadius,
  fontSize,
};
